import {MainBreakoutRoomId} from '../constants';

export const isDuplicateRoomName = (newName: string, existingNames: string[]) =>
    existingNames.includes(newName) || newName === MainBreakoutRoomId;
